import { getDeviceInfo } from '@williamhill/rosi-ui-shared/src/lib/device-info';

const device = getDeviceInfo();

const getDeviceInfoForLog = () => {
  return device
    ? {
        deviceId: device.deviceId,
        cluster: '',
        namespace: process.env.NODE_ENV,
        venueId: device.slotId.venueId,
        venueCode: device.slotId.venueCode,
        deviceType: device.slotId.type,
        slotNumber: device.slotId.slotNumber
      }
    : {
        deviceType: ''
      };
};

const constructBasicLogInfo = (errorType: string = 'info', msg: string) => {
  const deviceInfo = getDeviceInfoForLog();
  return JSON.stringify({
    '@t': new Date(Date.now()).toISOString(),
    '@n': location ? location.pathname : '/',
    thread_name: deviceInfo['deviceType'],
    v: 1,
    device: deviceInfo,
    '@l': errorType.toUpperCase(),
    '@m': msg
  });
};

const methods = ['debug', 'info', 'error', 'warn'];

export default methods.reduce((logger: any, method: string) => {
  logger[method] = (msg: string) => console[method](constructBasicLogInfo(method, msg));
  return logger;
}, {});
